import React from 'react';

import { navigate } from 'gatsby';

import { useAxeptio } from '../hooks/useAxeptio';
import { getSectionId } from '../utils/getters';

const ButtonNativeElement = ({
  style,
  disabled,
  button = {},
  ariaLabel,
  children,
  onClick
}) => {
  const { openAxeptioPopUp } = useAxeptio();

  // Destructuring button object
  const {
    isDownload,
    tabIndex,
    pathname,
    article,
    page,
    isOpenAxeptioModal,
    scrollTo
  } = button;

  // Build internal paths
  const internalPath = pathname
    ? pathname
    : article
    ? `${article.gatsbyPath}`
    : page
    ? `${page.gatsbyPath}${scrollTo ? `#${getSectionId(scrollTo)}` : ''}`
    : null;

  return (
    <button
      className={style}
      type="button"
      onClick={() => {
        if (isOpenAxeptioModal) {
          openAxeptioPopUp();
        }
        if (internalPath) {
          navigate(internalPath);
        }
        if (onClick) {
          onClick();
        }
      }}
      disabled={disabled}
      download={isDownload}
      aria-label={ariaLabel}
      name={ariaLabel}
      tabIndex={tabIndex}
      role={internalPath ? 'link' : ''}
    >
      {children}
    </button>
  );
};

export default ButtonNativeElement;
